import React from 'react';
import { useHistory } from 'react-router-dom';
import Layout from '../../components/layout/Layout';
import CompanyAuth from '../../components/auth/CompanyAuth';
import { isAuth } from '../../actions/auth';
import './CompanyDashboard.css';

const CompanyDashboard = () => {
    const history = useHistory();
    const user = isAuth();
    const dashboardCards = [
        {
            title: 'Company News',
            description: 'Create and manage your company news posts',
            icon: '📰',
            route: '/admin/all-company-news',
            color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            stats: 'Manage your news submissions'
        },
        {
            title: 'Job Posts',
            description: 'Post and manage job opportunities',
            icon: '💼',
            route: '/admin/all-jobs',
            color: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
            stats: 'Attract top talent'
        }
    ];

    return (
        <Layout>
            <CompanyAuth>
                <div className="company-dashboard">
                    <div className="dashboard-header">
                        <h1>Welcome back, <span className="company-name">{user?.name || 'Company'}</span>! 👋</h1>
                        <p className="dashboard-subtitle">Manage your company's presence on InfoEthiopia</p>
                    </div>

                    <div className="dashboard-cards">
                        {dashboardCards.map((card, index) => (
                            <div
                                key={index}
                                className="dashboard-card"
                                onClick={() => history.push(card.route)}
                                style={{ background: card.color }}
                            >
                                <div className="card-icon">{card.icon}</div>
                                <div className="card-content">
                                    <h3>{card.title}</h3>
                                    <p>{card.description}</p>
                                    <span className="card-stats">{card.stats}</span>
                                </div>
                                <div className="card-arrow">→</div>
                            </div>
                        ))}
                    </div>

                    <div className="quick-tips">
                        <h3>Quick Tips</h3>
                        <div className="tips-grid">
                            <div className="tip-card">
                                <span className="tip-icon">✨</span>
                                <p>Keep your news posts updated to engage your audience</p>
                            </div>
                            <div className="tip-card">
                                <span className="tip-icon">🎯</span>
                                <p>Post job opportunities to attract the best candidates</p>
                            </div>
                        </div>
                    </div>
                </div>
            </CompanyAuth>
        </Layout>
    );
};

export default CompanyDashboard;
